// extracted by mini-css-extract-plugin
export default {"ItemsWrapper":"UserSegmentsDropdown_ItemsWrapper__mS4+W","Slide":"UserSegmentsDropdown_Slide__BxtK0","Active":"UserSegmentsDropdown_Active__zDYX9"};